import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHourglass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHourglass"><Path fillRule="evenodd" clipRule="evenodd" d="M21 2V3.5H19V8.41045L13.3913 12L19 15.5896V20.5H21V22H3V20.5H5V15.5896L10.6087 12L5 8.41045V3.5H3V2H21ZM6.5 7H17.5V3.5H6.5V7ZM17.5 16.4104V18H6.5V16.4104L12 12.8904L17.5 16.4104Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHourglass;
